module.exports = __webpack_public_path__ + "static/media/Business deal-bro 1.d572b8e9.svg";